<template>
  <v-content>
    <v-container>
      <v-layout 
        align-center 
        justify-center>
        <v-flex xs12
          sm4
          align-center >
          <img
            src="/img/logo-login.png"
            class="logo"
          />       
        </v-flex>
      </v-layout>
      <v-layout
        flex
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm5
        >
          <v-card class="login-box">
            <v-card-text class="pt-4">
              <v-toolbar-title >
                <h2>Log in</h2>
              </v-toolbar-title>
              <div>
                <ValidationObserver ref="observer" tag="form" @submit.prevent="login">
                    <ValidationProvider rules="required|email|min:5|max:50" v-slot="{ errors, valid }" name='email'>
                      <v-text-field
                        label="Email"
                        v-model="form.email"
                        data-vv-name="email"
                        data-vv-validate-on="none"
                        required
                        class="input"
                        :success="valid"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                    <ValidationProvider rules="required|min:5|max:20" v-slot="{ errors, valid }" name='password'>                    
                      <v-text-field
                      label="Password"
                      v-model="form.password"
                      data-vv-name="password"
                      data-vv-validate-on="none"
                      required
                      autocomplete="false"
                      class="input"
                      :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                      @click:append="() => (hidePassword = !hidePassword)"
                      :type="hidePassword ? 'password' : 'text'"                    
                      :success="valid"
                      :error-messages="errors"
                      />
                    </ValidationProvider>
                    <h4>{{termsAndCond}}<a href="https://ayresim.com/termscondition.html"  target="_blank">www.ayresim.com</a></h4>
                    <v-checkbox
                      v-model="checkboxTermsAcceptance"
                      required
                      name="checkboxTermsAcceptanceValidation"
                      label="Accept Terms & Conditions"
                    />
                    <v-layout wrapper-button class="mt-2" >
                      <v-btn type="submit" 
                      :disabled="!checkboxTermsAcceptance"
                      outlined color="primary">
                        Log in
                      </v-btn>
                      <v-btn v-if="showNewUser" 
                      :disabled="!checkboxTermsAcceptance"
                      outlined color="primary" 
                      :to="{name : 'create-account'}">
                        New user
                      </v-btn>
                    </v-layout>
                    <v-layout wrapper-button class="mt-2">
                      <v-btn text :to="{name : 'forgot-password'}">
                        Reset your password
                      </v-btn>
                    </v-layout>
                </ValidationObserver>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="showResult"
      :timeout="2000"
      top
    >{{ result }}</v-snackbar>
  </v-content>
</template>

<script>
import AppConfig from '@/config/appConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import storageUtil from '@/helpers/storage'
import validations from '@/modules/validations'
import AuthApi from '@/api/auth'
import Vue from 'vue'
import mixinAppName from '@/mixins/appName'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      termsAndCond:"Please read the Terms and Conditions exposed in Ayres Alternative Investments website - ",
      checkboxTermsAcceptance:false,
      hidePassword: true,
      form: {
        email: null,
        password: null,        
        phone_code: null,
        app: AppConfig.appName
      },
      showResult: false,
      result: null,
      appLogo: AppConfig.appLogo2,
      showNewUser: this.isAyresInstitutionalPortal()
    }
  },  
  mixins: [mixinAppName],
  methods: {
    login(){
      const vm = this 
      vm.$refs.observer.validate().then(valid => {
        if (valid) {
          return new Promise((resolve, reject) => {
            AuthApi.login(vm.form).then(
              data => {
                if(data.user.authentication_type == 'email' || data.user.phone_number>0)
                  this.$router.push({ name: 'verification-code', params: { temp_token: data.temp_token,email: data.user.email, authentication_type: data.user.authentication_type } })
                else
                  this.$router.push({ name: 'phone-registration', params: { temp_token: data.temp_token,email: data.user.email } })
              },
              error => {
                // setTimeout(() => {
                  Vue.notify({
                    group: 'general',
                    type: 'error',
                    text: error.message
                  })
                // }, 500)
              }
            )
          })
        }
      })
    }
  }
}
</script>
<style scoped>
.v-toolbar__title {
  width: 100%;
}
h2 {
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  text-align: left;
  color: black;
}
.login-box {
  border: 2px solid #244AB3;
  border-radius: 10% !important;
  min-height: 350px;
  min-width: 450px;
}
.logo {
       
  left: 40px;
}
.btn-login {
  background-color: #244AB3 !important;
  border-color: #244AB3 !important;
  border-radius: 45px;
  min-height: 48px;
  color: #244AB3;
}
.v-btn{
  text-transform: none !important;
}
.pt-4 {
  padding-top: 40px !important;
}
.wrapper-button {
  display: -webkit-box;
}
.v-btn {
  margin: 0 auto;
  display: flex;
}
</style>
